import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@/components/protected-route';
import { MainLayout } from '@/components/main-layout';
import { PageHeader } from '@/components/page-header';
import { DashboardStats } from '@/components/dashboard/stats';
import { ProductionWidget } from '@/components/dashboard/production-widget';
import { RecentOrders } from '@/components/dashboard/recent-orders';
import { DashboardChart } from '@/components/dashboard/chart';
import { InvoiceDetailDialog } from '@/components/orders/invoice-detail-dialog';
import { useState } from 'react';

export const Route = createFileRoute('/')({
  component: () => (
    <ProtectedRoute>
      <MainLayout>
        <Dashboard />
      </MainLayout>
    </ProtectedRoute>
  ),
});

function Dashboard() {
  const [isInvoiceDetailOpen, setIsInvoiceDetailOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(null);

  const handleViewDetails = (id: string) => {
    setSelectedInvoiceId(id);
    setIsInvoiceDetailOpen(true);
  };
  return (
    <div className="flex flex-col gap-6 min-w-0 max-w-full">
      <PageHeader title="Dashboard Overview" />

      <div className="space-y-6">
        <DashboardStats />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ProductionWidget />
          <DashboardChart />
        </div>

        <div className="grid grid-cols-1 gap-6">
          <div className="col-span-1 min-w-0">
            <RecentOrders onViewDetails={handleViewDetails} />
          </div>
        </div>
      </div>

      <InvoiceDetailDialog
        open={isInvoiceDetailOpen}
        onOpenChange={setIsInvoiceDetailOpen}
        orderId={selectedInvoiceId}
      />
    </div>
  );
}
